import { createContext, useContext } from 'react';
import { defaultTheme } from '../constants';
const defaultState = {
    theme: defaultTheme,
    collapsible: false,
    indentSize: 2,
};
export const XMLViewerContext = createContext(defaultState);
export const useXMLViewerContext = () => useContext(XMLViewerContext);
//# sourceMappingURL=xml-viewer-context.js.map